

$(function () {

   
 

    ($('.fullscreen-slider')).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        infinite: true,
        dots: true,
    });

    var sliders = {
        1: { slider: '.teaser-slider', itemCount: $('.teaser-slider .col').length, arrowNext: $('.teaser-slider').parent().parent().find('.next-teaser'), arrowPrev: $('.teaser-slider').parent().parent().find('.prev-teaser') },
        2: { slider: '.news-modul', itemCount: $('.news-modul .news').length, arrowNext: $('.next-moduls'), arrowPrev: $('.prev-moduls') },
        3: { slider: '.icon-modul', itemCount: $('.icon-modul .icons').length, arrowNext: $('.next'), arrowPrev: $('.prev') }
    };

    $('.prev-teaser').hide();
        $('.prev-moduls').hide();
        $('.prev').hide();

    $.each(sliders, function () {
         
        if(this.itemCount <= 4){

        
            ($(this.slider)).slick({
                slidesToShow: this.itemCount,
                slidesToScroll: 1,
                infinite: 0,
                nextArrow: this.arrowNext,
                prevArrow: this.arrowPrev,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true
                        }
                    }
                ],
                

            });
        }
        if (this.itemCount > 4) {
           
            ($(this.slider)).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: true,
                infinite: 0,
                arrows:false,
                nextArrow: false,
                prevArrow: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true
                        }
                    }
                ]
            });
        }

    });

    

    function isDoubleClicked(element: any) {
        if (element.data("isclicked")) return true;

        element.data("isclicked", true);
        setTimeout(function () {
            element.removeData("isclicked");
        }, 500);

        return false;
    }


    // #################################################
    // ########## slider mouse wheel ###################
    // #################################################

   
    ($('.slider-wrapper')).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        infinite: 0,
        nextArrow: $('.next-slider'),
        prevArrow:$('.prev-slider'),
        dots: false,
        
    });

    function debounce(func: any, wait: any, immediate: any) {
        var timeout: any;
        return function (this: any) {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);

        };

    };


    function slick_handle_wheel_event(e: any, slick_instance: any) {

        var direction = e.deltaX;
        /* vertical scrolling */
        //   Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        //   if (e.originalEvent.wheelDeltaY == -1) {
        //     e.preventDefault();
        //   }
        // console.log('e.deltaX): ' + e.deltaX);

        if (direction > 0) {
            
            slick_instance.slick("slickNext");
        }
        if($('.prev-slider').hasClass('slick-disabled')){
            e.preventDefault();
        }
        else if (direction < 0) {

            slick_instance.slick("slickPrev");
           
        }
    }


    var slick_handle_wheel_event_debounced: Function = debounce(
        slick_handle_wheel_event
        , 300, true
    );

    $(".slider-items").on("wheel", function (e) {

        slick_handle_wheel_event_debounced(e.originalEvent, $(".slider-wrapper"));

    });

   
});